import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENU.DASHBOARD',
    icon: 'bx bx-bar-chart-alt-2',
    link: '/dashboard',
  },
  {
    id: 2,
    label: 'MENU.EQUIPMENTS',
    icon: 'bx bx-devices',
    link: '/equipments',
  },
  {
    id: 3,
    label: 'MENU.EQUIPMENT_MAP',
    icon: 'bx bx-map-alt',
    link: '/equipment-map',
  },
  {
    id: 4,
    label: 'MENU.IMPORTATION',
    icon: 'bx bx-import',
    link: '/importation',
  },
  {
    id: 4,
    label: "MENU.SETTINGS",
    icon: "fas fa-cog",
    link: "/settings",
  },
];
